"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var LogoutComponent_1 = require("./LogoutComponent");
exports.default = LogoutComponent_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/LogoutComponent/index.js
// module id = 1694
// module chunks = 8